import type * as api from "./api";
import { sourceHelp, sourceTagText } from "./dataSource";
import { Hint } from "./Hint";

/** Design 26.11 F4: Sheet, App, or Sheet → app on a date. Nothing from an older API. */
export function SourceTag({ tag, stop }: { tag: api.DataSource | undefined; stop?: boolean }) {
  if (!tag) return null;
  return (
    <Hint text={sourceHelp(tag)} stop={stop}>
      <span className={`chip-flag ${tag.state === "app" ? "neutral" : ""}`.trim()} data-testid="source-tag" data-source={tag.state}>
        {sourceTagText(tag)}
      </span>
    </Hint>
  );
}
